var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row align-items-center mb-1" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-2 offset-md-4 text-right center" },
          [
            _c(
              "router-link",
              {
                staticClass: "btn btn-primary",
                attrs: { to: "/", role: "button" }
              },
              [_vm._v("\n          back\n        ")]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "form",
        {
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.update.apply(null, arguments)
            }
          }
        },
        [
          _c("div", { staticClass: "row justify-content-md-center" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "row" }, [
                _vm.options.length
                  ? _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("fg-select", {
                          attrs: {
                            label: "Select Sync Option",
                            list: _vm.options,
                            selectedKey: "id"
                          },
                          model: {
                            value: _vm.optionSelected,
                            callback: function($$v) {
                              _vm.optionSelected = $$v
                            },
                            expression: "optionSelected"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    _vm.optionSelected === "2"
                      ? _c("fg-input", {
                          attrs: {
                            type: "text",
                            label: "Custom Tags (Max 15)",
                            placeholder: "Enter Tags (comma separated)",
                            required: ""
                          },
                          model: {
                            value: _vm.csvTags,
                            callback: function($$v) {
                              _vm.csvTags = $$v
                            },
                            expression: "csvTags"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.optionSelected === "2"
                      ? _c("b", [_vm._v(_vm._s(_vm.tagCount))])
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    _c("fg-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: _vm.rules.csvVideoCodes,
                          expression: "rules.csvVideoCodes"
                        }
                      ],
                      attrs: {
                        type: "text",
                        label: "Video Codes (Max 15)",
                        placeholder: "Enter Video Codes (comma separated)",
                        "data-vv-name": "Video Codes",
                        "cus-name": "Video Codes",
                        "has-errors": _vm.errors,
                        "is-fields": _vm.fields,
                        required: ""
                      },
                      model: {
                        value: _vm.csvVideoCodes,
                        callback: function($$v) {
                          _vm.csvVideoCodes = $$v
                        },
                        expression: "csvVideoCodes"
                      }
                    }),
                    _vm._v(" "),
                    _c("b", [_vm._v(_vm._s(_vm.videoCount))])
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-6 text-center" }, [
              _vm.optionSelected.toString() === "1"
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-fill btn-block",
                      attrs: {
                        disabled: _vm.videoCount === 0 || _vm.videoCount > 15,
                        type: "submit"
                      }
                    },
                    [_vm._v("\n            Update Video Metadata\n          ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.optionSelected.toString() === "2"
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-fill btn-block",
                      attrs: {
                        disabled: _vm.videoCount === 0 || _vm.videoCount > 15,
                        type: "submit"
                      }
                    },
                    [_vm._v("\n            Update Custom Tags\n          ")]
                  )
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "clearfix" })
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("div", { staticClass: "h2" }, [
        _vm._v("Update/Sync Video Meta Data with JWPlayer")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-189202a3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-189202a3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/VideoMetaDat.vue
// module id = MGQI
// module chunks = 0